import { toBoolean } from '@kaltura-ott/tvpil';
import { action, observable } from 'mobx';
import { singleton, container } from 'tsyringe';

import { ONE_YEAR } from '../../utils/constants';
import { checkDocumentExist, CookieNameEnum, getCookie, setCookie } from '../../utils/cookies';
import { errorHandling } from '../../utils/error-handling';
import { DmsStore } from '../dms/dms-store';
import type { UserStore } from '../user/user-store';

/**
 * @category Store
 */
@singleton()
export class CookiesStore {
  static moduleName = 'CookiesStore';

  @observable cookieAccepted = false;
  // @ts-expect-error TODO Fix
  @observable cookiePolicyUrl;

  @errorHandling()
  async init() {
    this.checkCookieConfirmation();

    const dmsStore = container.resolve<DmsStore>('dmsStore');
    this.cookiePolicyUrl = dmsStore.dms.gdpr?.cookiePolicyUrl;
  }

  checkCookieConfirmation() {
    if (!checkDocumentExist()) return;

    const cookieAccepted = getCookie(CookieNameEnum.acceptCookie);
    if (cookieAccepted !== undefined) this.cookieAccepted = toBoolean(cookieAccepted);
  }

  /**
   * @argument userAgent: window.navigator.userAgent
   * @argument ipAddress: IP address
   */
  @action
  acceptCookiePromt(userAgent: string, ipAddress = '') {
    if (!checkDocumentExist()) {
      return;
    }

    const userStore = container.resolve<UserStore>('userStore');

    const log = {
      ip: ipAddress,
      date: new Date().getTime(),
      userAgent,
      userId: userStore.userData?.id,
    };

    setCookie(CookieNameEnum.acceptCookie, true, { 'max-age': ONE_YEAR });

    setCookie(CookieNameEnum.cookiesPromt, JSON.stringify(log), { 'max-age': ONE_YEAR });
    this.cookieAccepted = true;
  }
}
